<section class="container-capped py-2">
  <a class="btn btn-secondary m-10" (click)="openModal()">افزودن قالب تصویر</a>

  <section class="">
    <div class="kp-card d-flex justify-content-between" *ngFor="let template of templates;let i=index">
      <h5>{{template.Title}} [{{template.Width}}px]</h5>
      <header class="fs-sm f-gray">
        <span class="float-left">
          <i class="fa fa-edit fs-lg pointer m-1" (click)="openModal(template)" title="ویرایش"></i>
          <i class="fa fa-trash fs-lg pointer m-1" (confirm)="delete(template.Id)" title="حذف"></i>
        </span>
      </header>
    </div>
  </section>
</section>

<ngx-smart-modal #templateModal identifier="templateModal">
  <ngx-spinner name="action" [fullScreen]="false" type="timer"></ngx-spinner>
  <div class="container mt-5">
    <div class="row">
      <div class="col-6 form-group">
        <input type="text" name="title" placeholder="عنوان" [(ngModel)]="selected.Title">
      </div>
      <div class="col-6 form-group">
        <input type="number" inputmode="numeric" name="width" placeholder="عرض تصویر" [(ngModel)]="selected.Width">
      </div>
      <div class="col-12">
        <textarea class="w-100" name="html" dir="ltr" rows="5" placeholder="کد html"
          [(ngModel)]="selected.Html"></textarea>
      </div>
    </div>
    <div class="btn-group">
      <button class="btn btn-yellow" type="submit" (click)="save()">ذخیره</button>
    </div>
  </div>
</ngx-smart-modal>